import React from 'react';
import { IconProps } from '.';

const SvgColoredReport = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='url(#ColoredReport_svg__a)'
        d='M3 3a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 19 3v16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 3 19V3Z'
      />
      <path
        fill='#BCC1E6'
        d='M6 20.5v.5a1.5 1.5 0 0 0 1.5 1.5h12A1.5 1.5 0 0 0 21 21V6a1.5 1.5 0 0 0-1.5-1.5H19V19a1.5 1.5 0 0 1-1.5 1.5H6Z'
      />
      <path
        fill='#5AC27C'
        d='M6.25 6.85c0-.387.224-.7.5-.7h1c.276 0 .5.313.5.7v5.6c0 .386-.224.7-.5.7h-1c-.276 0-.5-.314-.5-.7v-5.6Z'
      />
      <path
        fill='#F4847D'
        d='M10 8.864c0-.394.224-.714.5-.714h1c.276 0 .5.32.5.714v3.572c0 .394-.224.714-.5.714h-1c-.276 0-.5-.32-.5-.714V8.864Z'
      />
      <path
        fill='#7E96F9'
        d='M13.5 4.842c0-.382.224-.692.5-.692h1c.276 0 .5.31.5.692v7.616c0 .382-.224.692-.5.692h-1c-.276 0-.5-.31-.5-.692V4.842Z'
      />
      <path
        fill='#AAB1B5'
        d='M5.75 14.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V15a.25.25 0 0 0-.25-.25H5.75ZM5.75 16.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25V17a.25.25 0 0 0-.25-.25h-7.5Z'
      />
      <defs>
        <linearGradient
          id='ColoredReport_svg__a'
          x1={6}
          x2={19.878}
          y1={3.083}
          y2={19.77}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E7E7ED' />
          <stop offset={1} stopColor='#F1F1F8' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SvgColoredReport;
